export var PIGGY_BANK_RUNNING_STATUS = {
  DRAFT: 'DRAFT',
  PENDING: 'PENDING',
  RUNNING: 'RUNNING',
  EXPIRED: 'EXPIRED',
  PAUSED: 'PAUSED',
  CANCELED: 'CANCELED'
};
export var PIGGY_BANK_PROGRESS = {
  FULL: 100,
  NEARLY_FULL: 75,
  HALF: 50,
  QUARTER: 25,
  EMPTY: 0
};
export var PIGGY_BANK_INFO_SCREEN_TYPE = {
  OFFER_COINS: 'OFFER_COINS',
  OFFER_COINS_LP: 'OFFER_COINS_LP',
  OFFER_COINS_VIP: 'OFFER_COINS_VIP',
  OFFER_COINS_LP_VIP: 'OFFER_COINS_LP_VIP'
};